{
  "pt": {
    "login": {
      "acceptTosPrefix": "Aceito os ",
      "acceptTos": "termos e condições",
      "acceptTosRequired": "Você deve aceitar os termos e condições para criar uma conta.",
      "auth/invalid-credential": "A senha  invlida para o email fornecido, ou no existe uma conta para este email.",
      "auth/invalid-email": "O endereço de e-mail não é válido.",
      "auth/too-many-requests": "Muitas solicitaes, tente novamente mais tarde.",
      "auth/network-request-failed": "Ocorreu um erro de rede. Verifique sua conexão e tente novamente.",
      "auth/invalid-action-code": "Por motivos de segurança, os links de redefinição de senha expiram após um tempo. Se você ainda precisa redefinir sua senha, pode solicitar um novo email de redefinição.",
      "auth-ziggu/invalid-invitation-code": "Verifique com a pessoa que compartilhou com você se há um novo link disponível. Se você já tem uma conta, faça login em vez disso.",
      "auth-ziggu/user-created": "Sua conta de usuário foi criada! 🎉 Estamos fazendo login agora, aguarde..",
      "title_login": "Bem-vindo de volta!",
      "title_password_forgot": "Esqueceu sua senha?",
      "title_password_reset": "Redefina sua senha",
      "title_expired_reset": "Ops, esse é um link expirado..",
      "title_expired_signup": "Este link de convite não está mais ativo",
      "title_signup": "Complete seu cadastro",
      "backToLogin": "Voltar ao login",
      "cookiePolicy": "Política de Cookies",
      "privacyPolicy": "Política de Privacidade",
      "googleLogin": "Entrar com Google",
      "emailAddress": "Endereço de email",
      "emailAddressRequired": "Endereo de email  obrigatrio",
      "emailAddressInvalid": "Digite um endereço de e-mail válido",
      "notification_error_session_expired": "Sua sessão expirou, faça login novamente.",
      "notification_error_no_access": "Sua conta não tem acesso.",
      "notification_success_logout": "Você saiu da sua conta.",
      "password": "Senha",
      "password_confirm": "Confirmação de senha",
      "passwordForgot": "Esqueceu sua senha?",
      "passwordRequired": "Senha é obrigatória",
      "passwordLengthRequired": "A senha deve conter pelo menos 8 caracteres",
      "passwordConfirmRequired": "Confirmação de senha é obrigatória",
      "passwordConfirmMatchRequired": "A confirmação de senha não corresponde",
      "success_password_forgot": "Se você tem uma conta ativa, um email de redefinição de senha foi enviado para {email}. Verifique a sua caixa de entrada de e-mail, o link de redefinição de palavra-passe expira em 1 hora.",
      "success_password_reset": "Redefinição de senha bem-sucedida, fazendo login agora...",
      "submit_login": "Entrar",
      "submit_password_forgot": "Solicitar redefinição de senha",
      "submit_password_reset": "Redefinir senha",
      "submit_expired_reset": "Solicitar uma nova redefinição de senha",
      "submit_expired_signup": "Voltar ao login",
      "submit_signup": "Criar conta",
      "termsandconditionsPolicy": "Termos e Condições"
    }
  }
}
